import {
  ModalBackdrop,
  ModalContent,
  Title,
} from 'components/RatingFormModal/RatingFormModal';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import LocalIcon from 'ui/LocalIcon';
import { black } from 'utils/style/colors';

interface IDisplayModeModalProps {
  isOpen: boolean;
  onCloseModal: () => void;
  title: string;
  children: React.ReactNode;
  maxWidth?: string;
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const BlurModal: React.FC<IDisplayModeModalProps> = ({
  isOpen,
  onCloseModal,
  title,
  children,
  maxWidth = '500px',
}) => {
  const handleBackdropClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) {
        onCloseModal();
      }
    },
    [onCloseModal]
  );

  return (
    <ModalBackdrop isOpen={isOpen} onClick={handleBackdropClick}>
      <ModalContent
        maxWidth={maxWidth}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
      >
        <LocalIcon
          iconName="x.svg"
          color={black}
          onClick={onCloseModal}
          isLink={true}
          style={{ position: 'absolute' }}
        />
        <Title>{title}</Title>
        <Content>{children}</Content>
      </ModalContent>
    </ModalBackdrop>
  );
};

export default BlurModal;
